import { render, staticRenderFns } from "./DispatchSummaryFooter.vue?vue&type=template&id=4dc1fed0&scoped=true"
import script from "./DispatchSummaryFooter.vue?vue&type=script&lang=js"
export * from "./DispatchSummaryFooter.vue?vue&type=script&lang=js"
import style0 from "./DispatchSummaryFooter.vue?vue&type=style&index=0&id=4dc1fed0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc1fed0",
  null
  
)

export default component.exports